export interface BaseCrudProxy {
  id: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  instanceId: string;
}

export const EmptyBaseCrudProxy: BaseCrudProxy = {
  id: '',
  createdAt: '',
  updatedAt: '',
  isActive: true,
  instanceId: '',
};